import { createMuiTheme, MuiThemeProvider, Typography, withStyles, Tooltip, TableCell, Snackbar, Switch } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { useEffect, useReducer, useState } from "react";
import api from "../api";
import MuiAlert from '@material-ui/lab/Alert';
import icFilter from '../../assets/ic_filter.png';
import FilterDataRoom from "./FilterDataRoom";
import Loader from 'react-loader-spinner'
import ReactExport from 'react-data-export';
import ic_downloadFile from '../../assets/ic_downloadFile.png';
import { format } from 'date-fns';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;


const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptions()

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const style = {
    position: "sticky",
    zIndex: 110
};

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);


export default function MonitoringRuangan(props) {
    const [dataTable, setDataTable] = useState([])
    const [visibleCreate, setVisibleCreate] = useState(false)
    const [loading, setLoading] = useState(false)
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [create, setCreate] = useState(false);
    const [read, setRead] = useState(false);
    const [update, setUpdate] = useState(false);
    const [deleted, setDeleted] = useState(false);
    const [dataRoom, setDataRoom] = useState([])
    const [dataBuilding, setDataBuilding] = useState([])
    const [average, setAverage] = useState(null)
    const [saveRoom, setSaveRoom] = useState(null)
    const [saveHari, setSaveHari] = useState(null)
    const [multiDataSet, setMultiData] = useState([])
    const [download, setDownload] = useState(false)
    const [unused, setUnused] = useState(false)

    useEffect(() => {
        setLoading(true)
        getPermission(props)
        getRoomFilter()
        getBuildingFilter()
    }, [])

    const getPermission = (e) => {
        api.create().getPermission(e.menuid).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setCreate(data.create)
                    setUpdate(data.update)
                    setRead(data.read)
                    setDeleted(data.delete)
                }
            }
        })
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const getRoomFilter = () => {
        api.create().getRoomFilter("activeinactive=1").then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.sort((a, b) => Number(a.name) - Number(b.name)).map((item) => {
                        data.push(item)
                    })
                    setDataRoom(data)
                    setLoading(false)
                } else {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("warning")
                }
            }
        })
    }

    const getBuildingFilter = () => {
        api.create().getBuildingFilter("activeinactive=1").then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.sort((a, b) => Number(a.name) - Number(b.name)).map((item) => {
                        data.push(item)
                    })
                    setDataBuilding(data)
                    setLoading(false)
                } else {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("warning")
                }
            }
        })
    }

    const handleFilter = (payload, value) => {
        console.log(value);
        if (value === 0) {
            console.log("terpakai");
            api.create().FilterMonitoringRuangan(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        if (response.data.data.length > 0) {
                            let data = []
                            response.data.data.map((item) => {
                                item.detail.map((i, idx) => {
                                    data.push({
                                        tgl: item.date,
                                        jamMulai: i.time_start,
                                        jamSelesai: i.time_end,
                                        dokter: i.doctor,
                                        klinik: i.polyclinic
                                    })
                                })
                            })
                            if (data.length > 0) {
                                let dataTable = data.map((item, index) => {
                                    return [
                                        item.tgl,
                                        item.jamMulai,
                                        item.jamSelesai,
                                        item.dokter,
                                        item.klinik,
                                    ]
                                })
                                setDataTable(dataTable)
                                setMessageAlert(response.data.message)
                                setOpenAlert(true)
                                setStatusAlert("success")
                            }
                            setVisibleCreate(false)
                            setUnused(false)
                            forceUpdate()
                        } else {
                            setDataTable([])
                            setMessageAlert("Data Tidak Tersedia")
                            setOpenAlert(true)
                            setStatusAlert("Warning")
                            setVisibleCreate(false)
                        }
                    }
                }
            })
        } else {
            api.create().FilterMonitoringRuanganKosong(payload).then(response => {
                console.log("tidak terpakai");
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        if (response.data.data.length > 0) {
                            let data = []
                            let dataTable = response.data.data.map((item, index) => {
                                let day = []
                                if (item.days && item.days.length > 0) {
                                    item.days.map((items) => {
                                        console.log(items);
                                        day.push(items)
                                    })
                                }
                                return [
                                    item.building,
                                    day.join(", "),
                                    item.floor,
                                    item.room,
                                    item.time_start,
                                    item.time_end,
                                ]
                            })
                            setDataTable(dataTable)
                            setMessageAlert(response.data.message)
                            setOpenAlert(true)
                            setStatusAlert("success")

                            setVisibleCreate(false)
                            setUnused(true)
                            forceUpdate()

                        } else {
                            setDataTable([])
                            setMessageAlert("Data Tidak Tersedia")
                            setOpenAlert(true)
                            setStatusAlert("Warning")
                            setVisibleCreate(false)
                        }
                    }
                }
            })
        }
    }

    const forceUpdate = useReducer(bool => !bool)[1];

    const columns = [{
        name: "Tanggal",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, "Jam Mulai", "Jam Selesai", "Nama Dokter", "Klinik"];
    const columnsUnsused = [{
        name: "Gedung",
        options: {
            sort: true,
            customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white' }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, "Hari", "Lantai", "Ruangan", "Jam Mulai", "Jam Selesai"];

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {loading ? loadingComponent : null}
            <div style={{ width: '100%', display: 'flex', margin: '5px 0', justifyContent: 'space-between', position: 'relative' }}>
                <div style={{ display: 'flex' }}>
                    <button style={{ padding: '5px 10px', backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                        onClick={() => setVisibleCreate(true)}
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img style={{ width: 16, height: 16, marginRight: 7 }} src={icFilter} />
                            <Typography style={{ fontSize: 14, margin: 'auto', margin: '0 3px', color: 'white' }}>Filter Data</Typography>
                        </div>
                    </button>
                    {saveRoom !== null && (
                        <div style={{ marginLeft: 20, display: 'flex' }}>
                            <div style={{ width: 30, height: 10, borderRadius: 10, backgroundColor: '#278863', margin: '5px 13px 0 0' }} />
                            <div>
                                <Typography style={{ fontSize: 14, color: '#868686' }}>Ruangan</Typography>
                                <Typography style={{ fontSize: 18, color: '#000000', fontWeight: '500', lineHeight: 1 }}>{saveRoom.name}</Typography>
                            </div>
                        </div>
                    )}
                    {saveHari !== null && (
                        <div style={{ marginLeft: 20, display: 'flex' }}>
                            <div style={{ width: 30, height: 10, borderRadius: 10, backgroundColor: '#49ea6e', margin: '5px 13px 0 0' }} />
                            <div>
                                <Typography style={{ fontSize: 14, color: '#868686' }}>Hari</Typography>
                                <Typography style={{ fontSize: 18, color: '#000000', fontWeight: '500', lineHeight: 1 }}>{saveHari.name}</Typography>
                            </div>
                        </div>
                    )}
                </div>
                {/* {download && (
                    <div style={{ alignSelf: 'center', position: 'absolute', top: 63, right: 100, zIndex: 2 }}>
                        <ExcelFile
                            element={
                                <LightTooltip title={"Download"} arrow>
                                    <div style={{ cursor: 'pointer', display: 'flex' }}>
                                        <img src={ic_downloadFile} style={{ width: 24, height: 24, marginRight: 16 }} />
                                    </div>
                                </LightTooltip>
                            }
                            filename={`Report Fasilitas ${format(new Date(saveTglMulai), 'dd-MM-yyyy')} - ${format(new Date(saveTglSelesai), 'dd-MM-yyyy')}`}
                        >
                            <ExcelSheet dataSet={multiDataSet} name="Sheet" />
                        </ExcelFile>
                    </div>
                )} */}
            </div>
            {unused ?
                <div >
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={dataTable}
                            columns={columnsUnsused}
                            options={options}
                        />
                    </MuiThemeProvider>
                </div>
                :
                <div >
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={dataTable}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                </div>
            }

            {visibleCreate && (
                <FilterDataRoom
                    onClose={() => setVisibleCreate(false)}
                    dataRoom={dataRoom}
                    dataBuilding={dataBuilding}
                    saveRoom={saveRoom}
                    saveHari={saveHari}
                    handleFilter={(payload, room, hari, building, floor, timestart, timeend, value) => {
                        console.log(room, hari);
                        handleFilter(payload, value)
                        setSaveRoom(room)
                        setSaveHari(hari)
                    }}
                />
            )}
        </div>
    )
}